import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook for retrieving query parameters of current URL, if any.
 *
 * @function
 * @returns {Object} {@link https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams}
 * instance for current URL query string.
 */
export const useQuery = () => {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
};
